package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initThe_requested_resource_does_not_exist_on_this_serverPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/the_requested_resource_does_not_exist_on_this_server.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/the-requested-resource-does-not-exist-on-this-server")
@Layout(".components.layouts.DocsLayout")
@Composable
fun The_requested_resource_does_not_exist_on_this_serverPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("the-requested-resource-does-not-exist-on-this-server") }) {
        org.jetbrains.compose.web.dom.Text("The requested resource does not exist on this server")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Bot-hosting.net mainly offers two pages for hosting and managing your bots:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Manage panel (")
            com.varabyte.kobweb.silk.components.navigation.Link("https://bot-hosting.net/panel/") {
                org.jetbrains.compose.web.dom.Text("https://bot-hosting.net/panel/")
            }
            org.jetbrains.compose.web.dom.Text(")")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Control panel (")
            com.varabyte.kobweb.silk.components.navigation.Link("https://control.bot-hosting.net/") {
                org.jetbrains.compose.web.dom.Text("https://control.bot-hosting.net/")
            }
            org.jetbrains.compose.web.dom.Text(")")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Each page has its own login system. You need to log in on both pages with the same account to see the same servers.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This error usually means you are not using the same account on both pages, or you are using an account that does not have access to the server you are trying to open. To fix it, use the logout icon in the Control panel and log in with the correct account.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("how-can-i-do-that") }) {
        org.jetbrains.compose.web.dom.Text("How can I do that? ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#id-4lo1kaqtmsy");attr("id", "id-4lo1kaqtmsy")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Go to the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://control.bot-hosting.net/") {
            org.jetbrains.compose.web.dom.Text("control panel")
        }
        org.jetbrains.compose.web.dom.Text(" and click the logout button.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (36).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Log in again with Discord and make sure the authorization page shows the correct user, meaning the one who has access to the server. Compare it with the user shown in the Manage panel.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (37).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (38).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

}
